import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  key: 1,
  class: "q-mt-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_primary_insights = _resolveComponent("primary-insights")!
  const _component_secondary_insights = _resolveComponent("secondary-insights")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_posts_last_imported = _resolveComponent("posts-last-imported")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_primary_insights, { account: _ctx.account }, null, 8, ["account"]),
    (_ctx.showMore)
      ? (_openBlock(), _createBlock(_component_secondary_insights, {
          key: 0,
          "account-id": _ctx.account.id,
          class: "q-my-md"
        }, null, 8, ["account-id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_btn, {
      label: _ctx.showMore ? 'View Less Insights' : 'View More Insights',
      "icon-right": _ctx.showMore ? 'fa fa-arrow-up' : 'fa fa-arrow-down',
      color: "grey-2",
      "text-color": "dark",
      rounded: "",
      unelevated: "",
      "no-caps": "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMore = !_ctx.showMore)),
      class: "q-my-lg"
    }, null, 8, ["label", "icon-right"]),
    (_ctx.account.postsUntil)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.account.postsUntil)
            ? (_openBlock(), _createBlock(_component_posts_last_imported, {
                key: 0,
                time: _ctx.account.postsUntil,
                class: "text-body1 text-italic"
              }, null, 8, ["time"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}